<script>
import OptionSummarize from './Option/Summarize.vue';
import OptionSpeechToText from './Option/SpeechToText.vue';
import TranscribePlayer from './Transcribe/Player.vue';
import axios from 'axios';

export default {
    props: {
        text: {
            type: String,
            required: true
        }
    },

    components: {
        OptionSummarize,
        OptionSpeechToText,
    },

    data() {
        return {
            isOpenOptions: false,
            selliaActionResponse: {type: 'hidden', message: ""},
            iconByHover: 'PodcastMicrophone',
            isStopRecognition: false,
            isListening: false,
            isSummarizing: false,
            isFeatureEnabled: false,
            isCheckingSelliaFeatureFlag: false,
        }
    },

    computed: {
        selliaActionResponseClass() {
            if (this.selliaActionResponse.type == 'action') {
                return "sellia-button-summarizing";
            }
            if (this.selliaActionResponse.type == 'info') {
                return "sellia-button-response";
            }
            return "sellia-button-hidden";
        },  

        isRecordingType() {
            return this.selliaActionResponse.type == 'recording';
        },
    },

    methods: {
        handleClick() {
            if (this.isSummarizing) {
                return;
            }

            if (this.isRecordingType) {
                this.handleStopRecognition();
            } else {
                this.handleToggleOptions();
            }
        },

        handleStopRecognition() {
            this.resetSelliaActionResponse();
            this.isStopRecognition = false;
        },

        handleToggleOptions(isAuto = false) {
            if (!this.isFeatureEnabled && !isAuto) {
                Alert.error('SelliA está temporariamente indisponível. Estamos ajustando alguns detalhes, em breve, ela estará de volta!');
                return;
            }

            this.isOpenOptions = !this.isOpenOptions;

            if (!isAuto) {
                this.resetSelliaActionResponse();
            }
        },

        hideSelliaActionResponse() {
            const timeout = this.selliaActionResponse.timeout;
            
            if (timeout) {
                setTimeout(() => {
                    this.resetSelliaActionResponse(true);
                }, timeout);
            }
        },

        resetSelliaActionResponse(keep = false) {
            const type = keep ? this.selliaActionResponse.type : 'hidden';

            this.selliaActionResponse = {type: type, message: ""};
        },

        handleMouseOver() {
            this.iconByHover = 'UpArrowInsideCircle';
        },
        
        handleMouseLeave() {
            this.iconByHover = 'PodcastMicrophone';
        },
    },

    watch: {
        isRecordingType(value) {
            if (!value) {
                this.isListening = false;

                this.$emit('isRecordingType', false);
            } else {
                this.$emit('isRecordingType', true);
            }
        }
    },
    
    async mounted() {
        try {
            this.isCheckingSelliaFeatureFlag = true;

            const response = await axios.get('/integration/ai/sellia-feature-flag');
            this.isFeatureEnabled = response.data.active;
        } catch (error) {
            this.isFeatureEnabled = false;
        } finally {
            this.isCheckingSelliaFeatureFlag = false;
        }

        Bus.$on('selliaActionResponse', (response) => {
            if (this.selliaActionResponse.type !== 'hidden' && response.type !== 'hidden') {
                this.handleToggleOptions(true);
            }
            this.selliaActionResponse = response;
            this.hideSelliaActionResponse();
        });

        Bus.$on('selliaOptionBuilderClick', (response) => {
            if (response === 'summarize') {
                this.isSummarizing = true;
            }

            this.handleToggleOptions(true);
        });

        Bus.$on('selliaOptionBuilderClickFinished', (response) => {
            if (response === 'summarize') {
                this.isSummarizing = false;
                this.isOpenOptions = false;
            }
        });
    }
}
</script>

<template>
    <div>
        <button 
            id="sellia-button" 
            class="bg-sellia-gradient text-white px-2-5 py-2-5 d-flex justify-content-center align-items-center rounded-circle border-0 position-absolute bottom-12 end-20"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
            :disabled="isCheckingSelliaFeatureFlag"
        >
            <template v-if="isRecordingType">
                <component :is="'Icon' +iconByHover" />
            </template>
            <IconTwoFourPointedStar v-else/>
        </button>
        <div v-if="selliaActionResponse.type != 'hidden' && selliaActionResponse.message" :class="selliaActionResponseClass" class="base-sellia-button lightest-blue rounded-pill d-flex align-items-center justify-content-between px-2-5 py-2 gap-2">
            <div class="gap-1 d-flex align-items-center justify-content-center">
                <component v-if="selliaActionResponse.icon" :is="selliaActionResponse.icon" />
                {{ selliaActionResponse.message }}
            </div>
        </div>
        <TranscribePlayer v-if="isRecordingType" :isStopRecognition="isStopRecognition" @listening="(value) => isListening = value" />
        <div class="sellia-button-tooltip" :class="{'hidden': !isOpenOptions}">
            <div class="sellia-button-tooltip-content">
                <OptionSummarize :text="text" :disabled="isRecordingType || isSummarizing" />
                <OptionSpeechToText :disabled="isRecordingType || isSummarizing" />
            </div>
        </div>
    </div>
</template>

<style>
.base-sellia-button {
    position: absolute;
    bottom: 16px;
    right: 68px;
    z-index: 1;
    line-height: 18px;
    font-size: 12px;
    font-weight: 400;
}

.lightest-blue {
    background-color: #F8F6FF;
}

.sellia-button-summarizing {
    color: #5061f2 !important;
}

.sellia-button-response {
   color: #71767D !important;
}

.bg-sellia-gradient {
    position: relative;
    overflow: hidden;
    z-index: 1;
}

.bg-sellia-gradient::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, #FF84DC, #96A7FF);
    z-index: -1;
    transition: opacity 0.3s ease;
}

.bg-sellia-gradient::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, #FF57E4, #3A63F4);
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.bg-sellia-gradient:hover::before {
    opacity: 0;
}

.bg-sellia-gradient:hover::after {
    opacity: 1;
}

.px-2-5 {
    padding-left: 12px;
    padding-right: 12px;
}

.py-2-5 {
    padding-top: 12px;
    padding-bottom: 12px;
}

.bottom-12 {
    bottom: 12px;
}

.end-20 {
    right: 20px;
}

.gap-2 {
    gap: 8px;
}

.gap-1 {
    gap: 4px;
}

.hidden :nth-child(0) {
    position: relative;
    overflow: hidden;
}

.hidden :nth-child(1) {
    position: absolute;
    top: 999px;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
}

#sellia-button:disabled {
    cursor: not-allowed;
}

</style>